import React from 'react';
import calculateScores from '../helpers/calculationScores';
import maturityMap from '../helpers/maturityMap'; 

const MaturityChart = ({ responses }) => {
  const maxScore = calculateScores();
   // Calculate the highest score for all the questions
    const sectionPercentages = maxScore.totalScore;
    // Calculate the total score based on the responses
    let totalPercentage = 0;
    Object.keys(responses).forEach(sectionKey => {
    const section = responses[sectionKey];
    Object.values(section).forEach(question => {
        totalPercentage += parseInt(question.value);
    });});

    // Create a switch statement to calculate the score per doraMetric
    // Initialize variables for each DORA metric
    let doraLT = 0; // Lead Time for Changes
    let doraDF = 0; // Deployment Frequency
    let doraCFR = 0; // Change Failure Rate
    let doraMTTR = 0; // Mean Time to Restore

    // Loop through the responses and calculate the score for each DORA metric
    Object.keys(responses).forEach(sectionKey => {
    const section = responses[sectionKey];
    Object.values(section).forEach(question => {
        const score = parseInt(question.value);
        switch (question.doraMetric) {
        case "Lead Time for Changes":
            doraLT += score;
            break;
        case "Deployment Frequency":
            doraDF += score;
            break;
        case "Change Failure Rate":
            doraCFR += score;
            break;
        case "Mean Time to Restore":
            doraMTTR += score;
            break;
        default:
            break;
        }
    });
    });    

    // Calculate the overall percentage
    const overallPercentage = Math.round((totalPercentage / sectionPercentages) * 100);
    const dltfcMaturity = maturityMap(doraLT, maxScore.doraMetrics.dltfc);
    const ddfMaturity = maturityMap(doraDF, maxScore.doraMetrics.ddf);
    const dcfrMaturity = maturityMap(doraCFR, maxScore.doraMetrics.dcfr);
    const dmttrMaturity = maturityMap(doraMTTR, maxScore.doraMetrics.dmttr);


  return (
    <div className="maturity-chart">
      <h2>Overall Organisational Maturity Score</h2>
      <h3>DORA</h3>
      <div className="score-display">
      <h4>Lead Time for Changes is <strong>{dltfcMaturity}</strong>:</h4>
      <h4>{doraLT} out of {maxScore.doraMetrics.dltfc}</h4>

      <h4>Deployment Frequency is <strong>{ddfMaturity}</strong>:</h4>
      <h4>{doraDF} out of {maxScore.doraMetrics.ddf}</h4>

      <h4>Change Failure Rate is <strong>{dcfrMaturity}</strong>:</h4>
      <h4>{doraCFR} out of {maxScore.doraMetrics.dcfr}</h4>

      <h4>Mean Time to Restore is <strong>{dmttrMaturity}</strong>:</h4>
      <h4>{doraMTTR} out of {maxScore.doraMetrics.dmttr}</h4>
    </div>
      <h3>Total Score</h3>
      <div className="score-display">
        <h4>{totalPercentage} out of {sectionPercentages}</h4>
      </div> 
      <div className="score-display">
        <h3>{overallPercentage}%</h3>
        <div className="progress-bar">
          <div
            className="progress"
            style={{ width: `${overallPercentage}%`, backgroundColor: '#1970DE' }}
          />
        </div>
      </div>
        <button onClick={() => window.location.reload()}>Restart Questionnaire</button>
        <h2>Questions and Answers</h2>
         {Object.keys(responses).map(sectionKey => (
            <div key={sectionKey}>
              <p>----</p>
               <h4><strong>Section: {sectionKey}</strong></h4>
               {Object.values(responses[sectionKey]).map((question, index) => (
                  <div key={index}>
                     <p><strong>Q:</strong> {question.question}</p>
                     <p><strong>A:</strong> {question.answer}</p>
                  </div>
               ))}
            </div>
         ))}
    </div>
      
  );
};

export default MaturityChart;
